<div class="personal-infomation p-4 mt-4">
    <div class="d-flex justify-content-between">
        <h2 class="profile-heading">Equipments</h2>
        <img class="edit-profile" (click)="editEquipments()"
            *ngIf="endCustomerData?.equipments && endCustomerData.equipments.length > 0 && !showEditForm" alt=""
            src="../../assets/images/editprofile.svg">
    </div>

    <div class="mt-2" *ngIf="!(endCustomerData?.equipments && endCustomerData.equipments.length > 0) && !showEditForm">
        <button (click)="editEquipments()" class="profile-btn">
            <mat-icon>add</mat-icon>
            <p class="ps-2">Add Equipments</p>
        </button>
    </div>

    <div class="mt-2 name-container"
        *ngIf="endCustomerData?.equipments && endCustomerData.equipments.length > 0 && !showEditForm">
        <div *ngFor="let equipment of equipmentData" class="my-3 skill-set">
            <span class="speciality">
                <label class="med-world-basic-font med-world-basic-font__grey">{{equipment?.name}}</label>
            </span>
        </div>
    </div>

    <div *ngIf="showEditForm" class="mt-2">
        <div class="row" [formGroup]="equipmentForm">
            <div class="col-lg-12">
                <div>
                    <p class="profile-h4 profile-h4__font-Weight-medium profile-h4__color">Select Equipment</p>
                </div>

                <div class="skillSetDopdownContainer">
                    <mat-form-field appearance="outline" class="input-font w-100 equipment skill-set-container"
                        [class.equipment_increase]="equipmentForm.get('equipments')?.value.length > 4"
                        (click)="equipmentInputFieldClicked()">

                        <mat-chip-listbox>
                            <mat-chip class="chip"
                                *ngFor="let equipment of equipmentForm.get('equipments')?.value; let i = index"
                                [removable]="true" (removed)="remove(i)">
                                {{ getEquipmentName(equipment) }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </mat-chip-listbox>

                        <input class="skillsInput search-equipment" type="text" matInput
                            placeholder="Search for equipments" (input)="filterEquipments($event)">
                    </mat-form-field>

                    <div class="multi-select-tag equipment-drop-down"
                        *ngIf="!noRecordsFoundData && isEquipmentInputFieldClicked">
                        <mat-option *ngFor="let equipment of filteredEquipments" class="mat-option-data"
                            [value]="equipment.id" (click)="checkBoxClicked(equipment)">
                            <mat-checkbox [checked]="equipmentForm.get('equipments')?.value.includes(equipment.id)"
                                (keyup)="keyDownButton(equipment, $event)"></mat-checkbox>
                            <span class="equipmentName">{{ equipment?.name }}</span>
                        </mat-option>
                    </div>

                    <div class="no-dropdown-data" *ngIf="noRecordsFoundData && isEquipmentInputFieldClicked">
                        <span>No Records Found</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="profile-action">
            <button class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3"
                (click)="update()">Update</button>
            <button class="mwe-button mwe-button--secondary ps-3 pe-3" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>

<!-- <p>equipments works!</p> -->
<!-- <div class="row" >
              
    <div
        class="col-lg-12">
        <div >
            <p class="profile-h4 profile-h4__font-Weight-medium  profile-h4__color ">Types of Equipment Available</p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="input-font w-100 equipment"
                [class.equipment_increase]="equipmentForm.get('equipments')?.value.length>4">
                <mat-select placeholder="Select" formControlName="equipments" multiple
                    >
                    <mat-select-trigger>

                        <mat-chip-listbox>
                            <mat-chip class="chip" *ngFor="let topping of infraStructureForm.get('equipments')?.value ; let i=index"
                                [removable]="true" (removed)="remove(i)">
                                {{ getEquipment(topping)}}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </mat-chip-listbox>
                    </mat-select-trigger>
                    <mat-option *ngFor="let equipment of equipments"
                        [value]="equipment.id">{{equipment?.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div class="profile-action " >
<button  class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3" (click)="update()">Update</button>
<button  class="mwe-button mwe-button--secondary ps-3 pe-3 "  (click)="cancel()">Cancel</button>
</div> -->